export default {
    title:`BUMMER, IT’S NOT A MATCH!`,
    h1:`Looks like {{firstName}} that you have a crush on is NOT the person who first contacted us. (And of course, your credit card was NOT charged.)`,
    h3:`We’ve sent {{firstName}} the anonymous note you customized with a hint earlier.`,
    done:`Good luck!`
}


// WEBPACK FOOTER //
// ./assets/strings/bummer.js